import Stack from "@mui/material/Stack";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { SxProps, Theme } from "@mui/material/styles";

import type { PropertyOptionType } from "../interfaces";

export interface DisplayPropertiesTableProps {
  properties: PropertyOptionType[];
  containerStyles?: SxProps<Theme>;
  wideValues?: boolean;
}

export const DisplayPropertiesTable = ({
  properties,
  containerStyles,
  wideValues,
}: DisplayPropertiesTableProps) => {
  return (
    <Stack spacing={2} sx={containerStyles}>
      {properties.map(({ label, value }) => (
        <Grid container key={`${label}-${value}`}>
          <Grid item xs={12} sm={!wideValues ? 6 : 4}>
            <Typography
              sx={{
                color: "text.disabled",
                fontWeight: 300,
              }}
              gutterBottom={!value}>
              {label}
            </Typography>
          </Grid>

          <Grid item xs={12} sm={!wideValues ? 6 : 8}>
            <Typography
              sx={{
                wordBreak: "break-word",
              }}>
              {value}
            </Typography>
          </Grid>
        </Grid>
      ))}
    </Stack>
  );
};
